<template>
<div class="userinfoshow">
    <user-title :msg="msg" />
    <user-reset-password-show />
</div>
  
</template>

<script>
import UserInfoShow from './UserInfoShow.vue'
import UserResetPasswordShow from './UserResetPasswordShow.vue'
import UserTitle from './UserTitle.vue'
export default {
  data(){
    return{
      msg:"修改密码"
    }
  },
  components: { UserInfoShow, UserTitle, UserResetPasswordShow },

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/user/UserResetPassword.vue